"use client";

import { c as _c } from "react/compiler-runtime";
import { Loader2Icon } from "lucide-react";
import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { addToCartAction } from "@/actions/cart";
import { useTranslations } from "@/i18n/client";
import { cn } from "@/lib/utils";
import { useCart } from "@/ui/hooks/use-cart";
import { useCartModal } from "@/zustand/storefront";
import { YNSButton } from "../yns/yns-button";
export const AddToCartButton = t0 => {
  const $ = _c(40);
  const {
    variant,
    subscription,
    product,
    domain,
    disabled,
    outOfStock,
    className,
    style
  } = t0;
  const t = useTranslations("Global.addToCart");
  const [pending, startTransition] = useTransition();
  const router = useRouter();
  const isDisabled = disabled || pending || !variant || outOfStock;
  const {
    openCartModal
  } = useCartModal();
  const {
    dispatch
  } = useCart();
  let t1;
  if ($[0] !== className) {
    t1 = cn("rounded-full w-full text-lg relative", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== dispatch || $[3] !== domain || $[4] !== isDisabled || $[5] !== openCartModal || $[6] !== product || $[7] !== router || $[8] !== subscription || $[9] !== variant) {
    t2 = async e => {
      if (isDisabled) {
        e.preventDefault();
        return;
      }
      openCartModal();
      startTransition(async () => {
        dispatch({
          type: "ADD_ITEM",
          subscription: subscription || null,
          product,
          variant
        });
        await addToCartAction({
          variantId: variant.id,
          subscriptionId: subscription?.id ?? null,
          domain
        });
        router.refresh();
      });
    };
    $[2] = dispatch;
    $[3] = domain;
    $[4] = isDisabled;
    $[5] = openCartModal;
    $[6] = product;
    $[7] = router;
    $[8] = subscription;
    $[9] = variant;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = pending ? "opacity-0" : "opacity-100";
  let t4;
  if ($[11] !== t3) {
    t4 = cn("transition-opacity ease-in", t3);
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== outOfStock || $[14] !== t) {
    t5 = outOfStock === true ? t("disabled") : t("actionButton");
    $[13] = outOfStock;
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <span className={t4}>{t5}</span>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const t7 = pending ? "opacity-100" : "opacity-0";
  let t8;
  if ($[19] !== t7) {
    t8 = cn("ease-out transition-opacity pointer-events-none absolute z-10", t7);
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Loader2Icon className="h-4 w-4 animate-spin" />;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8) {
    t10 = <span className={t8}>{t9}</span>;
    $[22] = t8;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isDisabled || $[25] !== style || $[26] !== t1 || $[27] !== t10 || $[28] !== t2 || $[29] !== t6) {
    t11 = <YNSButton id="button-add-to-cart" size="lg" type="submit" className={t1} style={style} onClick={t2} aria-disabled={isDisabled} aria-describedby="add-to-cart-msg" disabled={isDisabled}>{t6}{t10}</YNSButton>;
    $[24] = isDisabled;
    $[25] = style;
    $[26] = t1;
    $[27] = t10;
    $[28] = t2;
    $[29] = t6;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== disabled || $[32] !== t) {
    t12 = disabled ? t("noVariantSelected") : "\xA0";
    $[31] = disabled;
    $[32] = t;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== disabled || $[35] !== t12) {
    t13 = <p aria-hidden={disabled} className="mt-2 text-center text-muted-foreground text-xs" id="add-to-cart-msg">{t12}</p>;
    $[34] = disabled;
    $[35] = t12;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  let t14;
  if ($[37] !== t11 || $[38] !== t13) {
    t14 = <div className="flex-2">{t11}{t13}</div>;
    $[37] = t11;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
};